module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/610fb87d66b6749aeb96d475ceb62940.svg";